import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import authService from "../../services/auth.service";
import ToastComponent from "../Common/TaostComponent";
const AdminLogin = () => {
  const navigate = useNavigate();
  let params = useParams(); // calling the hook
  const data = {};
  data.userId = params.id;
  authService.adminLogin(data).then((res) => {
    if (res.status === 401) {
      ToastComponent(res.message, "error");
    } else {
      navigate("/my-games");
    }
  });
  return <>Loading....</>;
};

export default AdminLogin;
